// Tooltip
(function() {

  var cssClasses = {
    visible: 'tooltip_visible',
    bottomRight: 'tooltip_bottom_right',
    bottomleft: 'tooltip_bottom_left',
    top: 'tooltip_top'
  };

  var $tooltips = $('[data-tooltip-id]');

  if ($tooltips.isset()) {
    $tooltips.each(function() {
      var that = this;
      var $that = $(that);
      var tooltipId = $that.data('tooltip-id');
      var $tooltip = $('[data-tooltip-target="' + tooltipId + '"]').first();

      $that.on('mouseenter.tooltip click.tooltip', function(event) {
        var props = event.target.getBoundingClientRect();
        var left = props.left + (props.width);
        var marginLeft = -1 * ($tooltip.outerWidth());
        var tooltipPos = {};

        tooltipPos.top = props.top + props.height + 15 + 'px';

        if ($tooltip.hasClass(cssClasses.bottomRight)) {
          tooltipPos.left = left + 'px';
          tooltipPos.marginLeft = marginLeft + 'px';
        } else {
          tooltipPos.left = props.left + 'px';
        }
        $tooltip.css(tooltipPos).addClass(cssClasses.visible);
      });


      $that.on('mouseleave.tooltip', function() {
        $tooltip.removeClass('tooltip_visible');
      });

      $(document).on('click', function(event) {
        if (!$(event.target).closest($that).length) {
          $tooltip.removeClass('tooltip_visible');
        }
      });

      $(window).on('scroll touchmove', function() {
        if ($tooltip.hasClass('tooltip_visible')) {
          $tooltip.removeClass('tooltip_visible');
        }
      });
    });
  }


})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/tooltip/tooltip.js